import { useLocation, useParams } from 'react-router-dom';
import { useMemo } from 'react';

import BannerIndiceDiPenetrazionePageDettaglio from '../../../../../components/report/listaDriverPage/indice-di-penetrazione-dei-mercati/indice-di-penetrazione-dettaglio/BannerIndiceDiPenetrazionePageDettaglio';
import ContainerIndiceDiPenetrazionePageDettaglio from '../../../../../components/report/listaDriverPage/indice-di-penetrazione-dei-mercati/indice-di-penetrazione-dettaglio/ContainerIndiceDiPenetrazionePageDettaglio';
import { useReport } from '../../../../../api/hooks/useReport';
import { useIndicePentrazioneDettaglio } from '../../../../../api/hooks/useIndicePentrazioneDettaglio';
import { useSources } from '../../../../../api/hooks/useSources';
import { useEventsSearch } from '../../../../../api/hooks/useEventsSearch';

const IndiceDiPenetrazioneMercatiPageDettaglio = () => {
  const {  driverRoute, intermediarioName } = useParams<{
    driverRoute: string;
    intermediarioName: string;
  }>();

  const location = useLocation();
  const { id, driverId, indiceID , validated } = location.state || {};

const { report, loading: loadingReport, error: errorReport } = useReport(id);
const { elements, loading: loadingElements, error: errorElements } = useIndicePentrazioneDettaglio(id, driverId, indiceID);
const { sources, loading: loadingSources, error: errorSources } = useSources(id, driverId, indiceID);

const payload = useMemo(() => ({
  report_id: id,
  element_id: indiceID,
}), [id, indiceID]);

const { events } = useEventsSearch(payload);

  // Se in caricamento, mostra loading
  if (loadingReport || loadingElements || loadingSources) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  // Se errore nel fetch
  if (errorReport || errorElements || errorSources) {
    return <div className='p-6 text-red-600'>Errore nel caricamento dei dati.</div>;
  }

  // Ora che i dati sono caricati, cerco il mercato
  const intermediarioNormalized = intermediarioName?.trim().toLowerCase();

  const mercato = elements?.flatMap(el => el.raw_data ?? [])
    .find(m => m.market_name?.trim().toLowerCase() === intermediarioNormalized);

  // Se non trovato il mercato
  if (!mercato) {
    return (
      <div className='p-6 text-red-600'>
        Nessun mercato trovato per "{intermediarioName}"
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerIndiceDiPenetrazionePageDettaglio
        report={report}
        title={driverRoute!}
        mercato={mercato}
        reportId={id}
        driverId={driverId}
      />
      <div className="px-8 lg:px-16 py-8">
        <ContainerIndiceDiPenetrazionePageDettaglio
        elements={elements}
        mercato={mercato}
        title={driverRoute!}
        driverRoute={driverRoute!}
        id={id}
        driverId={driverId}
        sources={sources}
        indiceID={indiceID!}
        validated={validated}
        events={events}

      />
      </div>
    </div>
  );
};



export default IndiceDiPenetrazioneMercatiPageDettaglio;
